import { FC } from 'react';
import 'rc-collapse/assets/index.css';
import { Props } from './types';
import { PanelStyled } from './style';

const Panel: FC<Props & { children?: any }> = ({
  // custom
  palette,
  ...restProps
}) => (
  <PanelStyled
    {...restProps}
    // custom
    palette={palette}
  />
);

export default Panel;
